import {
  ModalContainer,
  ModalLayoutSlideUp,
} from '@kanda-libs/ks-design-library';
import type { MutableRefObject } from 'react';
import OpenBankingInfo from './OpenBankingInfo';

const OpenBankingMobileModal: React.FunctionComponent = function () {
  return (
    <ModalContainer id="open-banking-info">
      {({ id, handleClose, ref }) => (
        <ModalLayoutSlideUp
          id={id}
          onClose={handleClose}
          ref={ref as MutableRefObject<HTMLDivElement>}
        >
          <div className="flex flex-col">
            <OpenBankingInfo />
          </div>
        </ModalLayoutSlideUp>
      )}
    </ModalContainer>
  );
};

export default OpenBankingMobileModal;
